import React, { useState, useRef } from "react";
import Button from "components/Button";
import PropTypes from "prop-types";
import Avatar from "react-avatar";
import useOnClickOutside from "hooks/useOnClickOutside";
import "./index.scss";

const Dropdown = ({
  value,
  buttonLabel,
  buttonColor,
  buttonType,
  buttonBlock,
  iconOnly,
  icon,
  data,
  avatar,
  avatarName,
  className,
  ...props
}) => {
  const dropdownRef = useRef();
  const [listOpen, setListOpen] = useState(false);
  useOnClickOutside(dropdownRef, () => setListOpen(false));
  const handleDropdownClick = (e) => {
    setListOpen(!listOpen);
    e.stopPropagation();
  };

  return (
    <div
      className={`dropdown-wrapper ${className}`}
      ref={dropdownRef}
      {...props}
    >
      {avatar ? (
        <Avatar
          round
          name={avatarName}
          size={38}
          color="green"
          onClick={handleDropdownClick}
        />
      ) : (
        <Button
          label={buttonLabel}
          iconOnly={iconOnly}
          color={buttonColor}
          type={buttonType}
          block={buttonBlock}
          icon={icon}
          onClick={handleDropdownClick}
        />
      )}
      <div className={`dropdown-list ${listOpen ? "-show" : "-hidden"}`}>
        {data.map((item) => (
          <button
            className="drop-button"
            type="button"
            key={item.id}
            onClick={item.handleClick}
            data-value={value}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
};

Dropdown.propTypes = {
  value: PropTypes.string,
  iconOnly: PropTypes.bool,
  buttonLabel: PropTypes.string,
  buttonColor: PropTypes.string,
  buttonType: PropTypes.string,
  buttonBlock: PropTypes.bool,
  icon: PropTypes.string,
  avatar: PropTypes.bool,
  avatarName: PropTypes.string,
  className: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      handleClick: PropTypes.func.isRequired,
    })
  ).isRequired,
};

Dropdown.defaultProps = {
  value: null,
  iconOnly: false,
  buttonLabel: "",
  buttonColor: "white",
  buttonType: "solid",
  buttonBlock: false,
  icon: "",
  avatar: false,
  avatarName: "",
  className: "",
};

export default Dropdown;
